import Cookies from "js-cookie";
import $, { get } from "jquery";

export class API {
  static API_URI = process.env.REACT_APP_BASE_URL;
  static SHOPIFY_API_URI = process.env.REACT_APP_SHOPIFY_URL;
  static login_sts = "";
  static login_user = Cookies.get("username");

  static stsUpdate(pro) {
    API.login_sts = pro;
    return API.login_sts;
  }
  static getSts() {
    return API.login_sts;
    //return store;
  }
  //   static getData(){
  //     fetch('https://jsonplaceholder.typicode.com/photos')
  //     .then((res) => {
  //         return res.json();
  //     })
  //     .then((data) => {
  //         return data
  //     });
  // }

  static async storeSetting(type, formData) {
    switch (type) {
      case "get":
        console.log("Sending payload:", { type: "get", ...formData });

        return fetch(`${API.API_URI}store-details.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            type: "get",
            ...formData,
          }),
        }).then((resp) => resp.json());

      case "insert":
        console.log("Type:", type);
        return fetch(`${API.API_URI}store-details.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            type: "insert",
            ...formData,
          }),
        }).then((resp) => resp.json());

        case "inserttstoredata":
        console.log("Type:", type);
        return fetch(`${API.API_URI}store-details.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            type: "inserttstoredata",
            ...formData,
          }),
        }).then((resp) => resp.json());

      case "edit":
        console.log("Type:", type);
        return fetch(`${API.API_URI}store-details.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            type: "edit",
            ...formData,
          }),
        }).then((resp) => resp.json());

        case "edittstoredata":
        console.log("Type:", type);
        return fetch(`${API.API_URI}store-details.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            type: "edittstoredata",
            ...formData,
          }),
        }).then((resp) => resp.json());

      case "edit-update":
        console.log("Type:", type);
        return fetch(`${API.API_URI}store-details.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            type: "edit-update",
            ...formData,
          }),
        }).then((resp) => resp.json());

      case "list":
        console.log("Type:", type);
        return fetch(`${API.API_URI}store-details.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            type: "list",
          }),
        }).then((resp) => resp.json());

        case "listtstoredata":
        console.log("Type:", type);
        return fetch(`${API.API_URI}store-details.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            type: "listtstoredata",
          }),
        }).then((resp) => resp.json());

      default:
        return Promise.reject("Invalid API call type");
    }
  }

  static async addCatalog(props) {
    try {
      const data = new URLSearchParams({
        type: props.type,
        storedescription: props.storedescription,
        clu: props.clu,
        upc: props.upc,
        casePack: props.casePack,
        orderByCase: props.orderByCase,
        dept: props.deptCode,
        deptClass: props.deptClassCode,
        prices: JSON.stringify(props.prices),
        basePrice: props.basePrice,
        primaryvendor: props.primaryvendor,
        primaryVlu: props.primaryVlu,
        primaryminQty: props.primaryminQty,
        primaryorderCost: props.primaryorderCost,
        secondaryvendor: props.secondaryvendor,
        secondaryVlu: props.secondaryVlu,
        secondaryminQty: props.secondaryminQty,
        secondaryorderCost: props.secondaryorderCost,
        webDescription: props.webDescription,
        reason: props.reason,
        webShortDescription: props.webShortDescription,
        webLongDescription: props.webLongDescription,
        metawords: props.metawords,
        batteries: props.batteries,
        chokingHazard: props.chokingHazard,
        nso: props.nso,
        leExclusive: props.leExclusive,
        extraShippingCharge: props.extraShippingCharge,
        giftWrap: props.giftWrap,
        ageAppropriateness: props.ageAppropriateness,
        batteryType: props.batteryType,
        gender: props.gender,
        lowAge: props.lowAge,
        highAge: props.highAge,
        shippingType: props.shippingType,
        leItemCategory: props.leItemCategory,
        leCurrentCatalog: props.leCurrentCatalog,
        status: props.status,
        individualAges: props.individualAgesString,
        interests: props.interests1,
        skillBuilder: props.skillBuilder1,
        leCatalogDesignation: props.leCatalogDesignation1,
        trendCategory: props.trendCategory,
        taxCategory: props.taxCategory,
        availableOnWeb: props.availableOnWeb,
      });

      const res = await fetch(`${API.API_URI}addCatalog.php`, {
        method: "POST",
        body: data,
      });
      if (!res.ok) {
        throw new Error("Network response was not ok");
      }
      const getRes = await res.json();
      //console.log(getRes);
      return getRes;
    } catch (err) {
      console.error("Error", err);
    }

    // .then((response) => {
    //   const res= response.json();
    //   console.log(res)
    // }
    //   )
    // .catch((error) => console.error("Error:", error));

    // return fetch ('https://dealer.tvsgreen.com/tw/addCatalog.php', {
    //   method: 'POST', // or 'PUT', depending on the API
    //   headers: {
    //     'Content-Type': 'application/json'
    //   },
    //   body: JSON.stringify(data) // Convert data to JSON string
    // })
    // .then(response => response.json()) // Parse JSON response
    // .then(result => result(result))
  }

  static getEmployee(page) {
    let url = "";
    if (page.page === 0) {
      url = `${API.API_URI}employee.php`;
    } else {
      url = `${API.API_URI}employee.php?page=` + page.page;
    }
    return fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((resp) => resp.json());
  }

  static getData(page, perpage) {
    return fetch(`${API.API_URI}catalog.php?page=${page}&perpage=${perpage}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((resp) => resp.json());
  }

  static getData1(get) {
    //console.log(mergedParams);
    //return false;
    return fetch(`${API.API_URI}catalog.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(get),
    }).then((resp) => resp.json());
  }

  static fetchUpc(upcCode) {
    return fetch(`${API.API_URI}fetchUpc.php?upc=` + upcCode, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((resp) => resp.json());
  }

  static getDcsss() {
    return fetch(`${API.API_URI}dcss.php`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((resp) => resp.json());
  }

  static getSecificDcsss(dcss) {
    return fetch(`${API.API_URI}specificDcss.php?dcss=` + dcss, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((resp) => resp.json());
  }

  // static getDeparments() {
  //   return fetch(`${API.API_URI}deparments.php`, {
  //     method: "GET",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //   }).then((resp) => resp.json());
  // }

  // static getClasses() {
  //   return fetch(`${API.API_URI}classes.php`, {
  //     method: "GET",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //   }).then((resp) => resp.json());
  // }

  static getPriceLevels() {
    return fetch(`${API.API_URI}priceLevel.php`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((resp) => resp.json());
  }

  static getVendors() {
    return fetch(`${API.API_URI}vendor.php`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((resp) => resp.json());
  }

  static getUser(user) {
    const data = new URLSearchParams({
      name: user.name,
      pwd: user.pwd,
    });

    fetch(`${API.API_URI}login.php`, {
      method: "POST",
      body: data,
    })
      .then((response) => response.json())
      .catch((error) => console.error("Error:", error));
  }

  static getCustomer(page) {
    let url = "";
    if (page.page === 0) {
      url = `${API.API_URI}customer.php`;
    } else {
      url = `${API.API_URI}customer.php?page=` + page.page;
    }

    return fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((resp) => resp.json());
  }

  static getWebOrderData() {
    // let url = "";
    // if (page.page === 0) {
    //   url = `${API.API_URI}salesOrders.php`;
    // } else {
    //   url = `${API.API_URI}salesOrders.php?page=` + page.page;
    // }

    let url = `${API.API_URI}salesOrders.php`;

    return fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((resp) => resp.json());
  }

  static getSpecificWebOrderData(props) {
    return fetch(`${API.API_URI}salesOrderView.php?id=${props.id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((resp) => resp.json());
  }

  static getPurchaseOrder(page) {
    let url = "";
    if (page.page === 0) {
      url = `${API.API_URI}purchaseOrders.php`;
    } else {
      url = `${API.API_URI}purchaseOrders.php?page=` + page.page;
    }

    return fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((resp) => resp.json());
  }

  static getSalesRecipt(page) {
    let pageFrom = page.from || "";
    let pageTo = page.to || "";
    return fetch(
      `${API.API_URI}salesReceipt.php?fromDate=${pageFrom}&toDate=${pageTo}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    ).then((resp) => resp.json());
  }

  static getSalesOrderRecipts(props) {
    console.log(props);
    const data = new URLSearchParams({
      fromDate: props.fromdateMDY,
      toDate: props.todateMDY,
      selectedStore: props.store,
    });
    return fetch(`${API.API_URI}orderReceipts.php`, {
      method: "POST",
      body: data,
    }).then((resp) => resp.json());
  }

  static getSearchData(props) {
    return fetch(
      `${API.API_URI}getSearchData.php?searchKey=${props.searchKey}`
    ).then((response) => response.json());
  }

  static getSpecificData(props) {
    //console.log("check props",props)
    return fetch(`${API.API_URI}editCatalog.php?id=${props.id}`).then(
      (response) => response.json()
    );
  }

  static updateCatalogPrice(props) {
    const data = new URLSearchParams({
      itemnumber: props.itemnumber,
      price: JSON.stringify(props.prices), // Serialize prices object as JSON string
    });

    return fetch(`${API.API_URI}priceUpdate.php`, {
      method: "POST",
      body: data,
    }).then((response) => response.json());
  }

  static accessSetting(type, addroles) {
    switch (type) {
      case "getrole":
        return fetch(`${API.API_URI}setting.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            type: "getroles",
            id: Number(addroles),
          }),
        }).then((resp) => resp.json());
      case "getUserType":
        return fetch(`${API.API_URI}setting.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            type: "getUserType",
            id: addroles,
          }),
        }).then((resp) => resp.json());
      case "getrolebyid":
        return fetch(`${API.API_URI}setting.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            type: "getrolebyid",
            value: addroles,
          }),
        }).then((resp) => resp.json());
      case "deleteuserrole":
        return fetch(`${API.API_URI}setting.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            type: "deleteuserroles",
            value: addroles,
          }),
        }).then((resp) => resp.json());
      case "deleterole":
        return fetch(`${API.API_URI}setting.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            type: "deleteroles",
            value: addroles,
          }),
        }).then((resp) => resp.json());
      case "addrole":
        return fetch(`${API.API_URI}setting.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            type: "addrole",
            value: addroles,
            loginuser: Cookies.get("username"),
          }),
        }).then((resp) => resp.json());
      case "getuser":
        return fetch(`${API.API_URI}setting.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            type: "getuser",
            id: Number(addroles),
          }),
        }).then((resp) => resp.json());
      case "getcategory":
        return fetch(`${API.API_URI}setting.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            type: "getcategory",
          }),
        }).then((resp) => resp.json());
      case "submit":
        return fetch(`${API.API_URI}setting.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            type: "submit",
            value: addroles,
            loginuser: Cookies.get("username"),
          }),
        }).then((resp) => resp.json());
      case "submitAddUser":
        return fetch(`${API.API_URI}setting.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            type: "submitAddUser",
            value: addroles,
            loginuser: Cookies.get("username"),
          }),
        }).then((resp) => resp.json());
      case "sendMailToUser":
        return fetch(`${API.API_URI}setting.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            type: "sendMailToUser",
            value: addroles,
            loginuser: Cookies.get("username"),
          }),
        }).then((resp) => resp.json());
      case "submitEditUser":
        return fetch(`${API.API_URI}setting.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            type: "submitEditUser",
            value: addroles,
            loginuser: Cookies.get("username"),
          }),
        }).then((resp) => resp.json());
      case "getRolePermission":
        return fetch(`${API.API_URI}setting.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            type: "getRolePermission",
            value: addroles,
          }),
        }).then((resp) => resp.json());
      case "submitExtractData":
        return fetch(`${API.API_URI}extractfiles.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            value: addroles,
            type: "submitExtractData",
          }),
        }).then((resp) => resp.json());
        case "getStoreDetails":
        return fetch(`${API.API_URI}extractfiles.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            type: "getStoreDetails"
          }),
        }).then((resp) => resp.json());
      default:
      // Optionally handle other cases if necessary
      // return Promise.reject('Invalid type');
    }
  }

  static DataTableScript() {
    $("#myTable1").DataTable({
      paging: true,
      searching: true,
      ordering: true,
      order: [[2, ""]],
      info: true,
      lengthChange: true,
      pageLength: 25,
      responsive: true,
      colReorder: true,
      autoWidth: false,
      destroy: true,
      stateSave: true,
      layout: {
        topStart: {
          buttons: [
            "copy",
            "csv",
            "excel",
            "pdf",
            "print",
            {
              extend: "colvis",
              collectionLayout: "fixed columns",
              popoverTitle: "",
            },
          ],
        },
      },
    });
  }

  static async getLocationStoreCode(page) {
    try {
      const res = await fetch(`${API.API_URI}location.php`);
      // Check if the response is successful (status 200)
      if (!res.ok) {
        throw new Error("Network response was not ok");
      }
      const result = await res.json();
      return result;
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  //Shopify API

  static getShopifyProducts(props) {
    const data = new URLSearchParams({
      store_id: props.storeIdToFilter,
      after: props.nextCursor,
      before: props.previousCursor,
      action: props.clickAction,
      limit: props.limit,
    });
    console.log(props);
    return fetch(`${API.SHOPIFY_API_URI}api/productlist.php`, {
      method: "POST",
      body: data,
    }).then((resp) => resp.json());
  }

  static getShopifySpecificProduct(props) {
    const data = new URLSearchParams({
      store_id: props.store_id,
      product_legacyResourceId: props.product_legacyResourceId,
    });

    return fetch(`${API.SHOPIFY_API_URI}api/productEdit.php`, {
      method: "POST",
      body: data,
    }).then((resp) => resp.json());
  }

  static getShopifySpecificProductPriceUpdate(props) {
    const data = new URLSearchParams({
      store_id: props.store_id,
      productVariant_legacyResourceId: props.productVariant_legacyResourceId,
      newPrice: props.newPrice,
    });

    return fetch(`${API.SHOPIFY_API_URI}api/productPriceUpdate.php`, {
      method: "POST",
      body: data,
    }).then((resp) => resp.json());
  }
}
